import {ParkingLotDto, ParkingZoneDto} from '@lib/infrastructure';

export const getParkingNode = (nodeId: string, parkingLots: ParkingLotDto[], parkingZones: ParkingZoneDto[]) => {
  const foundParkingNode =
    parkingLots.find((parkingLot) => parkingLot.id === nodeId) ||
    parkingZones.find((parkingZone) => parkingZone.id === nodeId);
  return foundParkingNode;
};

export const getParkingLotId = (node: ParkingZoneDto | ParkingLotDto) => {
  if ('parentId' in node) {
    return node.parentId;
  }

  return node.id;
};
